import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.p`
	font-size: ${helpers.font.size.small};
	margin-bottom: 12px;
`
